import { render } from "./Panel4.vue?vue&type=template&id=c2e82fc8&ts=true"
import script from "./Panel4.vue?vue&type=script&lang=ts"
export * from "./Panel4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__